import {
    CLASS_PRODUCT_TILE_INIT_EVENT_ATTACHED,
    SELECTOR_TILE_SWATCH_SELECTED,
    SELECTOR_SIZE_BTN,
    SELECTOR_SIZE_BTN_SELECTED,
    SELECTOR_PRODUCT_TILE_INIT_EVENT_NOT_ATTACHED,
    SELECTOR_NOTIFY_ME_BTN,
    SELECTOR_AVAILABILITY_MSG,
    SELECTOR_AVAILABILITY_MSG_TEXT,
    SELECTOR_EARLY_ACCESS_CTA_SIGN_IN,
    SELECTOR_EARLY_ACCESS_CTA_SIGN_UP,
    SELECTOR_ADD_TO_CART_BTN,
    SELECTOR_SOLDOUT_MSG,
    SELECTOR_TILE_PRICE_WRAPPER,
    SELECTOR_PRODUCT_TILE_CONTAINER,
    ADDED_CLASS,
    CLASS_PRODUCT_TILE,
    PAGE_TILE_BTNS,
    MODAL_TILE_ITEMS,
    SELECTOR_PRODUCT_TILE_LINK
} from './productTileConstants';
import { queryFirst, queryAll, hasClass, addClass, removeClass, toggleClass } from '../domUtil';
import { getCustomerData, getProductInventoryData } from '../utils/ajaxData';
import { IN_STOCK_STATUS as IN_STOCK, NOT_AVAILABLE_STATUS as NOT_AVAILABLE, PREORDER_STATUS as PREORDER, HIDDEN_CLASS, ONE_SIZE_ID, ONE_SIZE_LABEL, SELECTED_CLASS, NOT_AVAILABLE_CLASS } from '../constants';
import { getProductInfo } from './utils/productTileData';
import { isTierEligibleForEarlyAccess } from '../product/helper';
const { initCarouselElement } = require('../components/swiperCarousel').default;
import { initPopoverAll } from '../popover';
import { EVENT_KEY_TAB } from '../constants';
import { initRadioGroupKeyboardNav, normalizeRadioGroup } from '../components/accessibleRadioGroup';
const enterAnimationView = require('../enterAnimationView');

let observer;

/**
 *
 * @param {Object} productTileEl - product container html element
 * @param {Object} [productInventory] Product inventory object
 * @param {string} [action] action (init,update)
 */
async function updateCTAs(productTileEl, productInventory, action) {
    const selectedColorElement = queryFirst(SELECTOR_TILE_SWATCH_SELECTED, productTileEl);
    const selectedSizeElement = queryFirst(SELECTOR_SIZE_BTN_SELECTED, productTileEl);
    const selectedColorValue = selectedColorElement?.dataset?.attrValue;
    const selectedSizeValue = selectedSizeElement?.dataset?.attrValue;

    const addToCartButton = queryFirst(SELECTOR_ADD_TO_CART_BTN, productTileEl);
    const notifyMeButton = queryFirst(SELECTOR_NOTIFY_ME_BTN, productTileEl);
    const soldoutMsgEl = queryFirst(SELECTOR_SOLDOUT_MSG, productTileEl);

    const availabilityMsg = queryFirst(SELECTOR_AVAILABILITY_MSG, productTileEl);
    const clubLillySignIn = queryFirst(SELECTOR_EARLY_ACCESS_CTA_SIGN_IN, productTileEl);
    // join
    const clubLillySignUp = queryFirst(SELECTOR_EARLY_ACCESS_CTA_SIGN_UP, productTileEl);
    if (clubLillySignIn) {
        addClass(clubLillySignIn, HIDDEN_CLASS);
    }
    if (clubLillySignUp) {
        addClass(clubLillySignUp, HIDDEN_CLASS);
    }

    if (addToCartButton) {
        removeClass(addToCartButton, ADDED_CLASS);
        addClass(addToCartButton, HIDDEN_CLASS);
        addToCartButton.disabled = true;
    }
    addClass(notifyMeButton, HIDDEN_CLASS);
    addClass(availabilityMsg, HIDDEN_CLASS);

    const productInfoVariants = getProductInfo(productTileEl);
    const product = productInfoVariants ? productInfoVariants[selectedColorValue] : null;

    let customerData;
    const isEarlyAccessProduct = product?.earlyAccess?.isEarlyAccessProduct;
    let loyaltyRestricted = false;

    if (isEarlyAccessProduct) {
        customerData = await getCustomerData();
        // update early access wishlist icon state
        const earlyAccessLockIcon = queryFirst('.js-early-access-plp-container .loyalty-early-access-lock-container', productTileEl);
        const earlyAccessWishlistIcon = queryFirst('.js-early-access-plp-container .pdp-wish-list', productTileEl);
        const earlyAccessRestricted = queryFirst('.loyalty-early-access-restricted', productTileEl);
        if (customerData.isAuthenticated) {
            if (customerData.isLoyaltyMember && isTierEligibleForEarlyAccess(product.earlyAccess)) {
                addToCartButton.disabled = !selectedSizeValue;
                notifyMeButton.disabled = !selectedSizeValue;
                addClass(earlyAccessLockIcon, HIDDEN_CLASS);
                removeClass(earlyAccessWishlistIcon, HIDDEN_CLASS);
            } else {
                loyaltyRestricted = true;
                removeClass(earlyAccessLockIcon, HIDDEN_CLASS);
                addClass(earlyAccessWishlistIcon, HIDDEN_CLASS);
                if (earlyAccessLockIcon) {
                    const { updateEarlyAccessLockTooltip } = require('../popover');
                    updateEarlyAccessLockTooltip(earlyAccessLockIcon, !!product.earlyAccess.isAnnualMemberGift);
                }
                if (customerData.isLoyaltyMember) {
                    const ineligibleMessage = earlyAccessRestricted?.dataset?.msgIneligibleTier;
                    if (ineligibleMessage) announceMessage(ineligibleMessage);
                }
            }
            if (!customerData.isLoyaltyMember) {
                removeClass(clubLillySignUp, HIDDEN_CLASS);
                const nonMemberMessage = earlyAccessRestricted?.dataset?.msgNonMember;
                if (nonMemberMessage) announceMessage(nonMemberMessage);
            }
        } else {
            loyaltyRestricted = true;
            removeClass(clubLillySignIn, HIDDEN_CLASS);
            removeClass(earlyAccessLockIcon, HIDDEN_CLASS);
            addClass(earlyAccessWishlistIcon, HIDDEN_CLASS);
            if (earlyAccessLockIcon) {
                const { updateEarlyAccessLockTooltip } = require('../popover');
                updateEarlyAccessLockTooltip(earlyAccessLockIcon, !!product.earlyAccess.isAnnualMemberGift);
            }
            const guestMessage = earlyAccessRestricted?.dataset?.msgGuest;
            if (guestMessage) announceMessage(guestMessage);
        }
    }

    if (!addToCartButton || !product) {
        // if not add to cart, other also should be N/A
        return;
    }

    const { masterId } = productTileEl.dataset;
    if (selectedSizeValue) {
        const productTileProductWrapper = productTileEl.closest('.product');
        productTileProductWrapper.dataset.pid = selectedSizeElement.dataset.variationId;
        productTileProductWrapper.dataset.wishlistId = selectedSizeElement.dataset.variationId;
        // update selected size input if exist
        const selectedSizeInput = queryFirst('.js-selected-size', productTileEl);
        if (selectedSizeInput) {
            // change size label ('1 SZ' to 'One Size'), if it is '1 SZ'
            selectedSizeInput.textContent = selectedSizeValue === ONE_SIZE_ID ? ONE_SIZE_LABEL : selectedSizeValue;
        }
    } else {
        const productSizesValues = Object.values(product.sizes);

        let atLeastOneVariantAvailable = false;
        let atLeastOneVariantHasNotifyMe = productSizesValues.some(size => {
            return size.isNotifyMeEnabled;
        });

        if (action === 'init' && productSizesValues.length !== 1) {
            const sizeElements = queryAll(SELECTOR_SIZE_BTN, productTileEl);
            atLeastOneVariantAvailable = sizeElements.some(sizeElement => {
                const { isNotAvailable } = sizeElement.dataset;
                return isNotAvailable === 'false';
            });
        } else {
            productInventory = productInventory || await getProductInventoryData(masterId);

            atLeastOneVariantAvailable = productSizesValues.some(size => {
                if (!productInventory || !(size.ID in productInventory.variants)) {
                    return false;
                }
                const { availabilityStatus } = productInventory.variants[size.ID];

                return availabilityStatus === IN_STOCK;
            });
        }

        toggleClass(addToCartButton, HIDDEN_CLASS, !(atLeastOneVariantAvailable && !loyaltyRestricted));
        toggleClass(notifyMeButton, HIDDEN_CLASS, loyaltyRestricted || atLeastOneVariantAvailable || !atLeastOneVariantHasNotifyMe);
        toggleClass(soldoutMsgEl, HIDDEN_CLASS, loyaltyRestricted || atLeastOneVariantAvailable || atLeastOneVariantHasNotifyMe);

        return;
    }

    const { ID: pid, isNotifyMeEnabled } = product.sizes[selectedSizeValue];

    productInventory = productInventory || (await getProductInventoryData(masterId));

    if (!productInventory?.variants?.[pid]) {
        return;
    }

    const { message: availabilityMessage, availabilityStatus } = productInventory.variants[pid];

    const isInStockAvailability = availabilityStatus === IN_STOCK;
    const isNotAvailableAvailability = availabilityStatus === NOT_AVAILABLE;
    const isPreorderAvailability = availabilityStatus === PREORDER;

    addToCartButton.disabled = !isInStockAvailability && !isPreorderAvailability;
    if (!isNotAvailableAvailability && !loyaltyRestricted) {
        removeClass(addToCartButton, HIDDEN_CLASS);
        announceMessage('This item is in stock and can be added to your tote.');
    }
    notifyMeButton.disabled = !isNotAvailableAvailability;
    toggleClass(notifyMeButton, HIDDEN_CLASS, loyaltyRestricted || !isNotAvailableAvailability || !isNotifyMeEnabled);
    toggleClass(soldoutMsgEl, HIDDEN_CLASS, loyaltyRestricted || !isNotAvailableAvailability || isNotifyMeEnabled);
    toggleClass(availabilityMsg, HIDDEN_CLASS, !isPreorderAvailability);

    if (isPreorderAvailability) {
        const availabilityMsgText = queryFirst(SELECTOR_AVAILABILITY_MSG_TEXT, productTileEl);

        availabilityMsgText.innerHTML = availabilityMessage;
        announceMessage('Check in-store availability for this item.');
    }

    if (!hasClass(notifyMeButton, HIDDEN_CLASS)) announceMessage('This item is out of stock. Select ‘Notify Me’ to get an alert when it becomes available.');
    else if (!hasClass(soldoutMsgEl, HIDDEN_CLASS)) announceMessage('This item is currently sold out and unavailable for purchase.');

}

/**
 * Attach tile specific events
 *
 * @param {HTMLElement} productTileEl  product tile element
 */
function attachTileEvents() {
    document.body.addEventListener('product:tile:cta:update', async e => {
        e.preventDefault();
        const productTileEl = e.target;

        if (!productTileEl) {
            return;
        }

        const { productInventory } = e.detail;
        await updateCTAs(productTileEl, productInventory, 'update');
    });
}

/**
 * Initialize product tile
 *
 * @param {HTMLElement} productTileEl  product tile element
 */
async function initVisibleElement(productTileEl) {
    const { isInitialized } = productTileEl.dataset;
    if (isInitialized) {
        return;
    }

    // for cases when event triggered before listners added would be used data attr
    productTileEl.dispatchEvent(
        new CustomEvent('product:tile:initialize', {
            bubbles: true,
            detail: {}
        })
    );

    // init swiper carousel
    const carouselEl = queryFirst('.js-tile-carousel', productTileEl);
    if (carouselEl) {
        initCarouselElement(carouselEl);
    }

    adaUpdateTile(productTileEl);

    productTileEl.dataset.isInitialized = true;

    await updateCTAs(productTileEl, null, 'init');

    // Enter animation is driven by a separate observer shared with marketing slots
    // so side-by-side tiles/slots start together (init stays early via 200px margin).
    const tileContainer = productTileEl.closest(SELECTOR_PRODUCT_TILE_CONTAINER);
    if (tileContainer) {
        observeTileEnterAnimation(tileContainer);
    }

    normalizeTileSizeRadios(productTileEl);

    initPopoverAll(productTileEl);
}

/** @type {IntersectionObserver|null} */
let enterAnimObserver = null;

/**
 * @returns {boolean}
 */
function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Observe tile container for enter animation using the same view options as PD slots.
 * @param {Element} tileContainer
 */
function observeTileEnterAnimation(tileContainer) {
    if (!tileContainer || hasClass(tileContainer, 'animate-up')) {
        return;
    }

    if (prefersReducedMotion() || !window.IntersectionObserver) {
        addClass(tileContainer, 'animate-up');
        return;
    }

    if (!enterAnimObserver) {
        enterAnimObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }
                addClass(entry.target, 'animate-up');
                enterAnimObserver.unobserve(entry.target);
            });
        }, enterAnimationView);
    }

    enterAnimObserver.observe(tileContainer);
}

/**
 * Callback for intersection observer - determines whether or not to initialize product tiles
 * @param {HTMLElement[]} productTiles list of observered product tiles
 */
function onIntersection(productTiles) {
    productTiles.forEach(async (media) => {
        // isIntersecting is more reliable than ratio alone (armed translate can skew ratios)
        if (!media.isIntersecting) {
            return;
        }
        const { target: productTileEl } = media;
        await initVisibleElement(productTileEl);
        observer.unobserve(productTileEl);
    });
}

/**
 * Ensure each tile size radiogroup has exactly one tabbable radio
 * This guarantees Tab can enter the size group even when no size is selected
 * @param {HTMLElement|Document} root
 */
function normalizeTileSizeRadios(root) {
    const container = root || document;
    normalizeRadioGroup(container, '.size-btn[role="radio"]', {
        selectedClass: SELECTED_CLASS,
        notAvailableClass: NOT_AVAILABLE_CLASS
    });
}

const initContainer = async container => {
    const allProductTilesElements = queryAll(SELECTOR_PRODUCT_TILE_INIT_EVENT_NOT_ATTACHED, container);

    const isContainEarlyAccessProducts = allProductTilesElements.some(element => element.dataset.isEarlyAccess === 'true');
    if (isContainEarlyAccessProducts) {
        // pre-cache customer data
        await getCustomerData();
    }

    if (!observer && window.IntersectionObserver) {
        observer = new IntersectionObserver(onIntersection, {
            // If the image gets within 200px of the top/bottom of the viewport, start the download.
            rootMargin: '200px 0px',
            threshold: 0.01
        });
    }

    if (!observer) return;

    allProductTilesElements.forEach(productTileEl => {
        observer.observe(productTileEl);
    });
};

/**
 * Updates tabindex for the product tile link.
 * @param {HTMLElement} productTileEl - product tile element
 */
function adaUpdateTile(productTileEl) {
    const tileLink = queryFirst(SELECTOR_PRODUCT_TILE_LINK, productTileEl);

    if (tileLink) {
        tileLink.setAttribute('tabindex', '0');
    }
}

/**
 * Attach event listeners only once
 */
function attachEventsListenersOnce() {
    attachTileEvents();
    const body = $(document.body); // use jQuery to get the 'body' element

    body.on('search:updateProducts', async function () {
        await initContainer(document);
    });

    body.on('search:showMore', async function () {
        Promise.resolve().then(() => initContainer(document));
    });

    body.on('minicart:tile:show', async function (e, containerEl) {
        const target = containerEl;

        if (!target) return;

        Promise.resolve().then(() => initContainer(target));
    });

    document.body.addEventListener('stylitics:bundle:tile:show', async function (e) {
        const target = e.detail?.[0] || e.target;

        if (!target) return;

        Promise.resolve().then(() => initContainer(target));
    });

    document.addEventListener('slot-loaded', async (e) => {
        const { target } = e;
        await initContainer(target);
    });

    let lastFocusByTab = false;

    document.addEventListener('keydown', (e) => {
        if (e.key === EVENT_KEY_TAB) lastFocusByTab = true;
    }, true);

    const resetModality = () => { lastFocusByTab = false; };
    // turn off keyboard navigation flag:
    document.addEventListener('pointerdown', resetModality, true);
    document.addEventListener('mousedown', resetModality, true);
    document.addEventListener('touchstart', resetModality, true);

    body.on('focusin', `${PAGE_TILE_BTNS}, ${MODAL_TILE_ITEMS}`, function () {
        const el = this;

        if (!lastFocusByTab) return;

        const inSheet = el.closest('.sheet-body-content'); // DOM or null
        const isModalTarget = el.matches(MODAL_TILE_ITEMS);
        const isPageBtn = el.matches(PAGE_TILE_BTNS);

        try { el.focus({ preventScroll: true }); } catch { el.focus(); }

        if (isModalTarget) {
            const holdX = window.scrollX, holdY = window.scrollY;
            requestAnimationFrame(() => {
                // in sheet
                if (inSheet) inSheet.scrollTop = inSheet.scrollHeight;
                window.scrollTo(holdX, holdY);
            });
        } else if (isPageBtn && !inSheet) {
            // on page
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const tile = el.closest(`.${CLASS_PRODUCT_TILE}`);
                    if (!tile) return;

                    const rect = tile.getBoundingClientRect();
                    const desiredOffset = 180;
                    const targetTop = Math.round(window.scrollY + rect.top - desiredOffset);
                    const maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
                    const clamped = Math.max(0, Math.min(targetTop, maxTop));

                    window.scrollTo({ top: clamped, behavior: 'smooth' });
                });
            });
        }

        lastFocusByTab = false;
    });

    initRadioGroupKeyboardNav('.clickable-swatch[role="radio"]', ['[role="radiogroup"]', '.color-swatches']);
    initRadioGroupKeyboardNav('.size-btn[role="radio"]', ['[role="radiogroup"]', '.size-container']);
}

/**
 * Code to process some funcions only once even multiple includes
 */
const initOnce = (() => {
    let initialized = false;

    return () => {
        if (!initialized) {
            initialized = true;
            attachEventsListenersOnce();
        }
    };
})();

const productTileCustom = async () => {
    initOnce();

    await initContainer(document);
};

export default productTileCustom;
